import { ReactElement } from 'react';

import { Inject } from '@odinjs/odin';
import { ModalService, TableAPI } from '@philips-internal/oswald-ui-components';
import Controller, { OnClose, OnDynamicContentRender, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { RenderEvent } from '@philips-internal/oswald-ui-core/lib/component/types';

import { ReactComponent as DownloadSVG } from '../../../resources/assets/commons/download.svg';
import { FilesListAliases, FragmentNames } from '../../codegen';
import { File } from '../../interfaces';
import { FileService, MessagesService } from '../../services';
import { Utils } from '../../utils';
import BaseController from '../BaseController';

@Controller({ fragment: FragmentNames.FILES_LIST })
export default class FilesListController extends BaseController {

  @Inject(FilesListAliases.TABLE_FILES)
  tableFiles!: TableAPI;

  messageId!: string;
  data: File[] = [];

  @OnClose(FilesListAliases.MODAL_FILES)
  onCloseModalFiles(): void {
    ModalService.close('files');
  }

  @OnMount(FilesListAliases.TABLE_FILES)
  onMountTabsContent(): void {
    this.messageId = (this.getContextData('messageId') as string);
    this.data = (this.getContextData('data') as File[]);
    this.loadTable();
  }

  @OnDynamicContentRender(FilesListAliases.TABLE_FILES)
  onRenderColumns(event: RenderEvent): void {
    switch (event.entry) {
      case 'actions':
        event.render((data: File): ReactElement => {
          const actions = [
            { title: 'product-manual.download', onClick: () => this.downloadFile(data), icon: DownloadSVG },
          ];
          return Utils.renderActionButtons(actions);
        });
       
        break;
    }
  }

  private loadTable(): void {
    this.tableFiles.setData(this.data.map(f => ({ id: f.id, fileName: f.fileName })));
  }

  private downloadFile(data: File): void {
    ModalService.openDialog({
      id: 'download-modal',
      fragment: 'download-modal',
      closeable: false,
    });

    MessagesService.downloadFile(this.messageId, data.id)
      .then(response => {
        const mimeType = response.mimeType || 'application/octet-stream';
        const blob = mimeType === 'text/plain' ? response.content : FileService.base64ToBlob(
          FileService.formatToBase64(response.content, mimeType)
        );
        FileService.exportFile(response.fileName, blob,  { mimeType });
      })
      .catch(console.error)
      .finally(() => {
        ModalService.close('download-modal');
      });
  }
}
